import { render, staticRenderFns } from "./product-avatar.vue?vue&type=template&id=017cccf3"
import script from "./product-avatar.vue?vue&type=script&lang=js"
export * from "./product-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports